<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ !ta_revised_workflow_id ? "Create" : "Edit" }} Step</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<app-task-analyses-revised-workflows-edit *ngIf="!ta_revised_workflow_id"></app-task-analyses-revised-workflows-edit>

<mat-tab-group *ngIf="ta_revised_workflow_id">
  <mat-tab label="Overview">
    <app-task-analyses-revised-workflows-edit ></app-task-analyses-revised-workflows-edit>
  </mat-tab>
  <mat-tab label="Hazards & Risks">
    <app-task-analyses-revised-workflows-hazards></app-task-analyses-revised-workflows-hazards>
  </mat-tab>
</mat-tab-group>

